import expressionStore from '../store/expressionStore';
import ExpressionPickerViewState from '../store/schema/ExpressionPickerViewState';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'setExpressionPickerViewStateToExpressionId',
    (expressionId: string, viewState: ExpressionPickerViewState) => {
        expressionStore.expressionPickerViewStates.set(expressionId, viewState);
    }
);
